export const malgorzataStarczewska = {
    'meta': {
        'title': 'Lekarz rezydent psychiatrii Małgorzata Starczewska • Centrum COLLIGO',
        'description': 'Jestem lekarzem w trakcie specjalizacji z psychiatrii. Ukończyłam studia na Wydziale Lekarskim Gdańskiego Uniwersytetu Medycznego'
    },
    'url': {
        'address': '/torun/zespol/psychiatra-malgorzata-starczewska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/malgorzata-starczewska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra w Toruniu Małgorzata Starczewska'
        }
    }
}